export default "__VITE_ASSET__DeMih5yn__"